import { Container } from '../../components/ui';
import RequerirPacienteId from '../../components/RequerirPacienteId';
import ContenedorGeneral from './ContenedorGeneral';

export default function MisTurnos() {
  return (
    <Container>
      <RequerirPacienteId titulo="Necesitamos tu ID para ver tus turnos">
        <ContenedorGeneral />
      </RequerirPacienteId>
    </Container>
  );
}
